module.exports = __webpack_public_path__ + "media/images/blog-image-2-50d87e6b38aa6f478809ac232aaf236f.jpg";